import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardHeader, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter,Input, Label } from "reactstrap";
import { getOrdersNotCollected,markCollected } from "network/ApiAxiosTickets"
import axios from "axios";

import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { updateOrder } from "network/ApiAxiosTickets";
import { selfSalesAll } from "network/ApiAxiosTickets";
import { getMainEventInfo } from "network/ApiAxiosEventsGetickets";
import { deleteOrder } from "network/ApiAxiosTickets";
import { updateOrderNotes } from "network/ApiAxiosTickets";
import { updateOrderQuantity } from "network/ApiAxiosTickets";

const OpenOrders = () => {
  const history = useHistory();
  const [orders, setOrders] = useState();
  const [orderss, setOrderss] = useState();
  const [modal, setModal] = useState(false);
  const [orderToEdit, setOrderToEdit] = useState();
  const [tempOrderToEdit, setTempOrderToEdit] = useState();
  const [reload, setReload] = useState("");
  const [mainEventInfo, setMainEventInfo] = useState(null);

  const role = JSON.parse(localStorage.getItem("user")).role
  const sellerID = JSON.parse(localStorage.getItem("user"))._id

  const toggle = () => setModal(!modal);
  
  useEffect(() => { 
    const runAsync = async () => {
      //const response = await getOrdersNotCollected("userTable");
      const response = await selfSalesAll(sellerID)
      const { data } = response;
      if (data.success) {
        setOrders(data.doc.map((orderItem)=>{
          return{
            ...orderItem,
            total:orderItem.total + ' €',
            cartText:orderItem.cart.map((cartItem)=>{
              return cartItem.qt + ' X ' + cartItem.name + ' ' + cartItem.checkinFrom.split('T')[0]
            }),
            cartTextt:orderItem.cart.map((cartItem)=>{
              return cartItem.qt + ' X ' + cartItem.name + ' ' + cartItem.checkinFrom.split('T')[0]
            }).toString()
          }
        }));
        fetchMainEventInfo(data.doc)
      }
    };
    runAsync();
  }, [reload]);

  function editOrder(e) {
    console.log(e.data)
    setOrderToEdit(e.data)
    setTempOrderToEdit(e.data)
    toggle()
  }

  const fetchMainEventInfo = async(e)=>{
    const ArrayPromises = []
    e.map((orderItem)=>{
        orderItem.cart.map((cartItem)=>{
            console.log('first promise--',cartItem.mainEventId)
            ArrayPromises.push(getMainEventInfo(cartItem.mainEventId))
        })
    })
    console.log(ArrayPromises)
    Promise.all(ArrayPromises).then((resp)=>{
        console.log(resp)
        setMainEventInfo(resp.map((respItem)=>{
            return {[respItem.data.event._id] : respItem.data.event.name}
        }))
        console.log('final---',resp.map((respItem)=>{
            return {[respItem.data.event._id] : respItem.data.event.name}
        }))
        console.log('final---',mainEventInfo)
    }).catch((err)=> console.log('main event fetch error',err))
  }

  const getRowStyle = (params) => {
    console.log('sssss--',params.data.deleted)
    if(params.data.deleted){
      return { background: 'red'}
    }
    if (params.node.rowIndex % 2 === 0) {
      return { background: "aliceblue" };
    }
  };

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleDeleteOrder = async()=>{
    const checkStock = await axios.post('https://new.geticketsonline.com/stripe/seller/delete/order',{cart: orderToEdit.cart})
    if(checkStock.data.success){
        const response = await deleteOrder(tempOrderToEdit)
        console.log(response.data.success)
        if(response.data.success){
          window.location.reload()
        }else{
            alert('Something went wrong please try again')
        }
    }else{
        alert('Something went wrong')
    }
  }

  const handleUpdateOrder = async()=>{
    let updatesArray=[]
    Promise.all(
      orderToEdit.cart.map((cartItem)=>{
        const newCartItem = tempOrderToEdit.cart.find((tempCartItem)=> tempCartItem._id == cartItem._id)
        if(cartItem.qt != newCartItem.qt){
          updatesArray.push({
            _id: cartItem._id,
            qt: cartItem.qt - newCartItem.qt
          })
        }
      })
    ).then(async(promiseResp)=>{
      if(updatesArray.length > 0){
        const checkStock = await axios.post('https://new.geticketsonline.com/stripe/seller/order/update',{updatesArray})
            if(checkStock.data.success){
                const response = await updateOrderQuantity(tempOrderToEdit._id, updatesArray)
                console.log(response.data.success)
                if(response.data.success){
                  window.location.reload()
                }else{
                    alert('Something went wrong please try again')
                }
            }else{
                alert('One of the events is out of stock')
            }
      }else{
        const resp = await updateOrderNotes(tempOrderToEdit.notes,tempOrderToEdit._id)
        if(resp.data.success){
          window.location.reload()
        }else{
          alert('Something went wrong')
        }
      }
    })


  }

  /*
     const handleCheckout = async()=>{
        setDisablePurchaseButton(true)
        const cart = JSON.parse(localStorage.getItem('cart'))
        const Seller = JSON.parse(localStorage.getItem("user"))._id;
        if(clientName!=""&&phone!=""&&loc){
            const checkStock = await axios.post('https://new.geticketsonline.com/stripe/seller/checkout',{cart})
            if(checkStock.data.success){
                const response = await checkoutAPI(cart,clientName,clientEmail,total,totalNow,Seller,loc,phoneCountryCode + '' + phone,notes)
                console.log(response.data.success)
                if(response.data.success){
                    setClientEmail("")
                    setClientName("")
                    setNotes('')
                    setModalOpen(!modalOpen)
                    clearCart() 
                    setDisablePurchaseButton(false)
                }else{
                    alert('Something went wrong please try again')
                }
            }else{
                alert('One of the events is out of stock')
                setClientEmail("")
                setClientName("")
                setModalOpen(!modalOpen)
                clearCart() 
                setDisablePurchaseButton(false)
            }
        }else{
            alert('Please fill all the fields')
            setDisablePurchaseButton(false)
        }
    }
  */

  return (
    <>
      <Container>
        <Row>
          <div className="col">
            <Card className="shadow" style={{ width:"100%"}}>
              <CardHeader>
                <p>Double click to open order</p>
              </CardHeader>
              <div className="ag-theme-alpine" style={{ height: 500, width:"100%"}}>
              
                <AgGridReact
                  rowData={orders}
                  animateRows={true}
                  onRowDoubleClicked={editOrder}
                  pagination={true}
                  paginationPageSize={20}
                  getRowStyle={getRowStyle}
                  onGridReady={onGridReady}
                  defaultColDef={{
                    flex: 1,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    columnHoverHighlight: true,
                    resizable: true,
                    suppressDragLeaveHidesColumns: false,
                  }}
                >
                  
                  <AgGridColumn field="clientName" minWidth="150" quickFilterText style={{textAlign:"center"}}></AgGridColumn>
                  <AgGridColumn field="total" headerName="Total" minWidth="80" filter="agNumberColumnFilter"></AgGridColumn>
                  <AgGridColumn
                    field="createdAt"
                    headerName="Date (Time add 1H)"
                    minWidth="200"
                  ></AgGridColumn>
                  <AgGridColumn field="cartTextt" minWidth="400"></AgGridColumn>
                </AgGridReact>
              </div>
            </Card>

            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>Order</ModalHeader>
              <ModalBody className="text-center">
                {orderToEdit && <>
                  <h3>Client Name:</h3> <p>{orderToEdit.clientName}</p>
                  <h3>Cart:</h3> 
                  {tempOrderToEdit && tempOrderToEdit.cart.map((cartItem)=>{console.log('-----log edit cart',cartItem)
                    return <Row key={cartItem._id} className="d-flex justify-content-center" >
                        <Input style={{width:'10%'}} className="p-0 mr-2" type='number' value={cartItem.qt}  onChange={(e)=> setTempOrderToEdit({...tempOrderToEdit,cart: tempOrderToEdit.cart.map((cartItemm)=> cartItem._id == cartItemm._id ? {...cartItemm, qt : e.target.value} : {...cartItemm} ) }) } /> 
                            <Label className=" align-self-center" > { 'X ' + ' ' + cartItem.checkinFrom.split('T')[0] + ' ' + Object.values(mainEventInfo.find((value) => Object.keys(value) == cartItem.mainEventId))[0] } €
                            </Label> 
                        </Row>
                  })}
                  <h3>Order Date:</h3> <p>{orderToEdit.createdAt.split('T')[0]}</p>
                  <h3>Total:</h3> <p>{orderToEdit.total}</p>
                  <h3>Notes:</h3> <Input value={tempOrderToEdit?.notes} onChange={(e)=> setTempOrderToEdit({...tempOrderToEdit,notes: e.target.value})} />
                  {
                    orderToEdit && <img src={'https://celebrationjump.com/public/whatsapptemp/' + orderToEdit._id + '.jpg'} ></img>
                  }
                </>}
              </ModalBody>
              <ModalFooter>
                <Button className=" btn-danger" onClick={()=> handleDeleteOrder(orderToEdit)} disabled={orderToEdit?.deleted} >Delete</Button>
                <Button className=" btn-info" onClick={()=>handleUpdateOrder(orderToEdit)} disabled={orderToEdit?.deleted} >Update Order</Button>
                <Button color="secondary" onClick={toggle}>Close</Button>
              </ModalFooter>
            </Modal>


          </div>
        </Row>
      </Container>
    </>
  );
};

export default OpenOrders;
